import type { InvoiceDebtFilters } from '@models/invoiceDebt'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const invoiceDebtsKeys = {
  root: ['invoiceDebts'] as const,
  list: (filters?: InvoiceDebtFilters) =>
    [
      ...invoiceDebtsKeys.root,
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
}

export const invoiceDebtsUrls = {
  root: keyToUrl(invoiceDebtsKeys.root),
  list: () => keyToUrl(invoiceDebtsKeys.root),
}
